import React, { Component } from "react"
import { AuthenticationLoginContainer } from "components/authentication/redux/AuthenticationContainers"

export class LoginPage extends Component {
    render() { return (<AuthenticationLoginContainer />) }
}